<template>
  <sPopover
    ref="menu"
    v-model="time_menu"
    :border="false"
    content-class="tender-terms time-menu"
    :disabled="disabled"
    manual
    :placement="'bottom-start'"
    trigger="click"
    width="358">
    <div
      slot="reference" 
      :class="(class_name || ' ml-6') + ' time-chip__wrapper'">
      <div
        v-if="label"
        class="time_label h8-text pl-4 pt-1"
        data-qa="time_label">
        {{ label }}
      </div>
      <div
        class="time-chip px-3"
        :class="{'disabled': disabled}"
        data-qa="time_chip">
        {{ sync_time }}
      </div>
    </div>
    <v-time-picker
      v-if="time_menu && !disabled"
      v-model="sync_time"
      color="var(--v-secondary__green_not_active-base)"
      format="24hr"
      full-width
      :locale="$i18n.locale"
      :max="max"
      :min="min"
      :use-seconds="second"
      @click:hour="saveHour"
      @click:minute="save"/>
  </sPopover>
</template>

<script>

export default {
  name: 'timeMenu',
  data() {
    return {
      time_menu: false,
    }
  },
  props: {
    time: String,
    disabled: Boolean,
    label: String,
    class_name: String,
    min: String,
    max: String,
    second: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    sync_time: {
      get() {
        return this.time
      },
      set(val) {
        this.$emit('update:time', val)
      }
    },
  },
  methods: {
    saveHour() {
      this.sync_time = this.sync_time.slice(0,3) + '00'
      this.$emit('changed', this.sync_time)
    },
    save() {
      //this.$refs.menu.save(this.sync_time)
      this.time_menu = false
      this.$emit('changed', this.sync_time)
    }
  },
  watch: {
    time_menu(val) {
      if (!val) {
        this.save()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.sFormItem.is-error .time-chip {
  border-color: var(--color-error) !important;
}
.time-chip {
  width: 175px;
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--white-color);
  border: 2px solid var(--v-main__green-base);
  border-radius: 31px;
  cursor: pointer !important;
  &.disabled {
    cursor: no-drop !important;
    color: gray;
    border-color: var(--main__green_locked);
    background: var(--secondary__green_locked);
  }
}

</style>
